import type { CalendarEvent } from 'owa-calendar-types';
import { isSeriesInstance } from 'owa-calendar-event-capabilities';
import { parseCollabSpace } from '../utils/parseCollabSpace';
import { getSeriesMasterCollabSpace } from '../utils/getSeriesMasterCollabSpace';
import {
    setSeriesMasterShareLink,
    setSeriesInstanceShareLink,
} from '../mutators/collabSpaceMutators';
import { getViewStateById } from '../selectors/collabSpaceSelectors';

export async function cacheSeriesMasterCollabSpace(event: CalendarEvent, viewStateId: string) {
    const viewState = getViewStateById(viewStateId);
    if (viewState?.seriesMasterShareLink || !isValidInstance(event)) {
        return;
    }

    if (viewState?.isShared === 'true' && viewState?.shareLink) {
        setSeriesMasterShareLink(viewState.shareLink, viewStateId);
    } else {
        const collabSpace = await getSeriesMasterCollabSpace(event);
        setSeriesMasterShareLink(parseCollabSpace(collabSpace).shareLink, viewStateId);
    }
}

export function cacheSeriesInstanceCollabSpace(event: CalendarEvent, viewStateId: string) {
    const viewState = getViewStateById(viewStateId);
    if (viewState?.seriesInstanceShareLink || !isValidInstance(event)) {
        return;
    }

    if (viewState?.isShared === 'false') {
        setSeriesInstanceShareLink(viewState?.shareLink, viewStateId);
    }
}

function isValidInstance(event: CalendarEvent) {
    return event.IsOrganizer && isSeriesInstance(event);
}
